import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../../components/Seo';

const DocsHome: React.FC = () => {
  return (
    <div className="pt-24">
      <Seo
        title="Docs | Cimmple"
        description="Browse product documentation for CimmpleFlow and CimmplePay. Start with integration guides, API references, and go-live resources."
      />

      <section className="pt-8 pb-10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl md:text-4xl font-display font-bold text-slate-900 dark:text-white mb-3 text-balance">
            Cimmple Docs
          </h1>
          <p className="text-lg text-slate-700 dark:text-dark-300 max-w-3xl mx-auto text-balance">
            Product documentation hub for integration partners and implementation teams.
          </p>
        </div>
      </section>

      <section className="pb-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Link to="/docs/cimmplepay" className="card-glow block h-full">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h2 className="text-xl font-display font-bold text-slate-900 dark:text-white mb-2">
                    CimmplePay Docs
                  </h2>
                  <p className="text-slate-700 dark:text-dark-300">
                    Integration guides, authentication, core flows, API quick reference, and go-live checklist.
                  </p>
                </div>
                <span className="text-primary-600 dark:text-primary-400 font-semibold whitespace-nowrap">
                  Open
                </span>
              </div>
            </Link>

            <Link to="/docs/cimmpleflow" className="card-glow block h-full">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h2 className="text-xl font-display font-bold text-slate-900 dark:text-white mb-2">
                    CimmpleFlow Docs
                  </h2>
                  <p className="text-slate-700 dark:text-dark-300">
                    High-level ERP documentation covering modules, workflows, setup foundations, and implementation scope.
                  </p>
                </div>
                <span className="text-primary-600 dark:text-primary-400 font-semibold whitespace-nowrap">
                  Open
                </span>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DocsHome;
